<template>
    <img class="bg" id="background-image" src="/site_assets/backgrounds/background.jpg" alt="">
    <div class="about">

      <section class="partie">
        <p class="about-text">Hi! My name is Emily-Rose, I’m 24 years old and I live near Paris, France. I’m passionate about digital art and enjoy blending creativity with technology. From video games to paper collages and videos, I have a multidisciplinary background. <br><br>
        I studied multimedia engineering at <a href="https://www.ingenieur-imac.fr/" target="_blank">IMAC</a> (Image, Multimedia, Audiovisual, Communication), part of <a href="https://www.esiee.fr/" target="_blank">ESIEE Paris</a>. In my third year, I spent a semester in Weimar, Germany, at <a href="https://www.uni-weimar.de/en/art-and-design/studies/media-art-and-design/medienkunstmediengestaltung-mfa/media-art-and-design-mfa/" target="_blank">Bauhaus University</a>, specializing in Media Art and Design. After that, I did a <a href="https://formations.univ-gustave-eiffel.fr/master/detail/arts-numeriques-et-cultures-visuelles-234" target="_blank">Master’s degree in Digital Art</a> at Gustave Eiffel University.</p>
      </section>

      <section class="partie">
        <h2 class="parties-titres">Education</h2>
        <h3>2024-2025 - <a href="https://emilyrose.fr/projects?filter=Master+ANCV" target="_blank">M2 Digital Art</a></h3>
        <p class="about-text">Gustave Eiffel University, <a href="https://formations.univ-gustave-eiffel.fr/master/detail/arts-numeriques-et-cultures-visuelles-234" target="_blank">Master ANCV</a>, Noisy-le-Grand (93) <br>I learned 3d modeling, the use of sensors, electronic textiles and arduino programming. I created a virtual reality experience for my <a href="https://dumas.ccsd.cnrs.fr/dumas-05273711" target="_blank">memoir</a>. </p>
        <h3>2023-2024 - <a href="https://emilyrose.fr/projects?filter=Bauhaus+University" target="_blank">Semester in Germany</a></h3>
        <p class="about-text">Bauhaus University, Weimar (Germany) <br>I was in the <a href="https://www.uni-weimar.de/en/art-and-design/studies/media-art-and-design/medienkunstmediengestaltung-mfa/media-art-and-design-mfa/" target="_blank">Media Art and Design</a> program. I worked on a photogrammetry project, designed a game on Unity and learned Java.</p>
        <h3>2021-2024 - <a href="https://emilyrose.fr/projects?filter=IMAC" target="_blank">Engineering school</a></h3>
        <p class="about-text"><a href="https://www.ingenieur-imac.fr/" target="_blank">IMAC</a> (<a href="https://www.esiee.fr/" target="_blank">ESIEE Paris</a>), Champs-sur-Marne (77) <br>IMAC (Image, Multimedia, Audiovisual, Communication) is a creative engineering school. I mainly learned programming, especially for the web and video games, short film creation and 3D.</p>
        <h3>2019-2021 - CPGE Maths-Physics</h3>
        <p class="about-text">Lycée Gustave Monod, Enghien-Les-Bains (95) <br>Preparation for national exams for engineering schools, specializing in mathematics and physics.</p>
      </section>

      <section class="partie">
        <h2 class="parties-titres">Work Experiences</h2>
        <h3>2024 - Internship at <a href="https://lucidrealities.studio/" target="_blank">Lucid Realities</a></h3>
        <p class="about-text">Lucid Realities is a virtual reality studio that creates VR experiences especially for museums. <br>I worked as a developer on an ongoing project, on Unity in C#.</p>
        <h3>Summer 2023 - Internship at <a href="https://www.superprod.net/fr/superprod-animation" target="_blank">Superprod Animation</a></h3>
        <p class="about-text">Supervised by Anthony Guiot. <br>Creation of a launcher for artists to launch animation projects with specific software and options, in Python and QML.</p>
        <h3>January 2023 - Tutored project for <a href="https://alicevision.org/#meshroom" target="_blank">Meshroom</a> (Mikros)</h3>
        <p class="about-text">Supervised by Fabian Castan. <br>Adding nodes to Meshroom (photogrammetry software) in Python from geolocation data.</p>
        <h3>2022-2023 - Community Manager for <a href="https://www.instagram.com/803z.mlv/" target="_blank">803Z</a></h3>
        <p class="about-text">Audiovisual and artistic association at Gustave Eiffel University. <br>Social media posts and graphic design.</p>
        <h3>Summer 2022 - Internship at <a href="https://pureemaison.com/" target="_blank">Purée Maison</a></h3>
        <p class="about-text">Creative communications agency - Kremlin-Bicêtre (94). <br>Creation of moodboards, illustrations, and front-end development of a mock-up section in HTML and SCSS.</p>
      </section>

      <section class="partie">
        <h2 class="parties-titres">Events</h2>
        <h3>2026 - <a href="https://www.newimages.art/fr" target="_blank">NewImages Festival</a></h3>
        <p class="about-text">I presented my project <a href="https://emilyrose.fr/projects/wild-updated">W.I.L.D</a> to the Carte Blanche category at the NewImages 2026 festival. I also gave a short presentation on the topic of my master thesis: non-linear narratives and immersion in virtual reality.</p>
        <div class="event-img">
          <img src="../../public/projects_assets/Master/wild_v2/wild_v2_newimages.jpg">
          <img src="../../public/projects_assets/Master/wild_v2/wild_v2_presentation.jpg">
        </div>

        <h3>2025 - <a href="https://www.lafermedubuisson.com/fr/festival-tout-ouie-2025" target="_blank">Tout’Ouïe Festival</a></h3>
        <p class="about-text">I took part in a <a href="https://emilyrose.fr/projects/24h-mapping">24-hour video mapping</a> challenge presented at the Tout'Ouïe festival taking place at La Ferme du Buisson in Noisiel.</p>
        <div class="event-img">
          <img src="../../public/projects_assets/Videos/24h_mapping/tout_ouie_1.jpg">
          <img src="../../public/projects_assets/Videos/24h_mapping/tout_ouie_2.jpg">
        </div>

        <h3>2024 - <a href="https://2024.amaze-berlin.de/" target="_blank">A MAZE. Festival</a></h3>
        <p class="about-text">I showcased the game <a href="https://emilyrose.fr/projects/dust-and-roses">Dust and Roses</a> with my coworker at the A MAZE. 2024 festival in Berlin.</p>
        <div class="event-img">
          <img src="../../public/projects_assets/Bauhaus/dust_and_roses/amaze_1.jpg">
          <img src="../../public/projects_assets/Bauhaus/dust_and_roses/amaze_2.jpg">
        </div>

        <!-- <h3>2022-2025 - 803Z events</h3>
        <p class="about-text"></p> -->
      </section>

      <section class="partie"> 
        <h2><a target="_blank" rel="noopener noreferrer" href="site_assets/CV_ER.pdf">CV en français</a></h2>
      </section>

      <section class="partie"> 
        <h2><a href="/about-site" class="about-site">About site</a></h2>
      </section>

    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage'
  };
  </script>
  
  <style scoped>

  .about {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
    gap: 40px;
    padding-bottom: 90px;
  }
  .partie {
    padding: 20px;
    max-width: 50%;
  }

  h3 {
    font-family: 'Avara Regular';
  }

  .about-text {
    margin-top: 0;
    padding-bottom: 30px;
    
  }

  a {
    color: var(--color-violet-clair);
    text-decoration: none;
  }
  #background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover; 
    object-position: center; 
    opacity: 0.4;
    z-index: -10;
  }

  .about-site {
    color: var(--color-rose);
    font-size: 16px;
  }

  .event-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-bottom: 80px;

    img {
      max-height: 200px;
      height: auto;
    }
  }

  

  @media (max-width: 768px) {
    .partie {
      max-width: max-content;
    }

    h2 {
      font-size: 24px;
    }

    h3 {
      font-size: 16px;
    }
  }

</style>


<!-- remplir le texte
 hover : projets liés
 photo
 -->